import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=0aa44534&scoped=true&"
import script from "./VideoForm.vue?vue&type=script&lang=js&"
export * from "./VideoForm.vue?vue&type=script&lang=js&"
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=0aa44534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa44534",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa44534')) {
      api.createRecord('0aa44534', component.options)
    } else {
      api.reload('0aa44534', component.options)
    }
    module.hot.accept("./VideoForm.vue?vue&type=template&id=0aa44534&scoped=true&", function () {
      api.rerender('0aa44534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/VideoForm.vue"
export default component.exports